import PlatformView from "views/PlatformView";
import HomeView from "views/Home/HomeView";

const Platform = { PlatformView, HomeView };

export default Platform;
